/* ============================================================
   PARCELPANEL TRACKING PAGE -- label into field.

   The theme's contact form labels its fields with placeholder text
   (NAME, EMAIL, MESSAGE) and keeps the real <label> visually
   hidden. ParcelPanel renders its labels the other way round: a
   visible <span> above each field, and an input with no
   placeholder at all. Nothing in CSS can move text from one
   element into another's placeholder, so this does it: for every
   field the app renders, the label's text is copied into the
   input's placeholder attribute. parcelpanel-theme.css then hides
   the span the accessible way -- it stays in the DOM because the
   input points at it with aria-labelledby -- but only once the
   placeholder is there, so a field is never left unlabelled.

   The widget is a Vue app that mounts after this script runs and
   re-renders its form on tab changes, on resize between the
   desktop and mobile layouts, and when a lookup is cleared. So
   the work is done once now and again after every subtree change
   inside the widget, coalesced to one pass per frame. Setting an
   attribute is not a subtree change, so the observer does not
   re-trigger itself.

   Loaded on every page with `defer`; exits at once when the page
   has no widget.
   ============================================================ */
(function () {
  var app = document.getElementById('pp-tracking-page-app');
  if (!app || !('MutationObserver' in window)) return;

  var sync = function () {
    var rows = app.querySelectorAll('.pp_tracking_parent');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('.pp_tracking_span, label');
      var input = rows[i].querySelector('input');
      if (!label || !input) continue;
      var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
      if (text && input.getAttribute('placeholder') !== text) {
        input.setAttribute('placeholder', text);
      }
    }
  };

  var queued = false;
  var schedule = function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  };

  sync();
  new MutationObserver(schedule).observe(app, { childList: true, subtree: true });
})();
